import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./i18n";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, loginApiRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <React.Fragment>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.Fragment>,
  document.getElementById("root")
);
